import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import VectorTileLayer from './vector-tile-layer';

var VectorTile = function VectorTile(pbf, end) {
  _classCallCheck(this, VectorTile);

  this.layers = pbf.readFields(readTile, {}, end);
};

export { VectorTile as default };

function readTile(tag, layers, pbf) {
  if (tag === 3) {
    var layer = new VectorTileLayer(pbf, pbf.readVarint() + pbf.pos);

    if (layer.length) {
      layers[layer.name] = layer;
    }
  }
}